export default {
    "success": true,
    "content": {
        "PremisessInfo":[
            {
                "id": 1,
                "projectId": "001",
                "typeId": 1,
                "statusId": 1,
                "locationId": 1,
                "building": "1",
                "section": "1",
                "floor": 1,
                "floorsNumber": 17,
                "ceilingHeight": "3,50",
                "number": "21",
                "rooms": 'СТ',
                "area": 18,
                "totalCost": 8000000,
                "price": 400000,
                "decoration": "с отделкой",
                "compass": "На Запад",
                "views": "На двор, на парк",
                "planPictureUrl": "http://crm.api/images/object1.png",
                "advantages": ["преимущество 1","преимущество 2"],
                "readyDate": "1 квартал 2026"
            },
            {
                "id": 2,
                "projectId": "001",
                "typeId": 1,
                "statusId": 1,
                "locationId": 1,
                "building": "1",
                "section": "1",
                "floor": 2,
                "floorsNumber": 17,
                "ceilingHeight": "3,50",
                "number": "21",
                "rooms": 2,
                "area": 56,
                "totalCost": 15000000,
                "price": 500000,
                "decoration": "White box",
                "compass": "На Юг",
                "views": "На двор, на парк",
                "planPictureUrl": "http://crm.api/images/object1.png",
                "advantages": ["преимущество 1","преимущество 2"],
                "readyDate": "2 квартал 2026"
            },
            {
                "id": 3,
                "projectId": "001",
                "typeId": 1,
                "statusId": 1,
                "locationId": 1,
                "building": "1",
                "section": "1",
                "floor": 3,
                "floorsNumber": 17,
                "ceilingHeight": "3,50",
                "number": "21",
                "rooms": 1,
                "area": 38,
                "totalCost": 10000000,
                "price": 300000,
                "decoration": "Без отделки",
                "compass": "На Север",
                "views": "На двор, на парк",
                "planPictureUrl": "http://crm.api/images/object1.png",
                "advantages": ["преимущество 1","преимущество 2"],
                "readyDate": "3 квартал 2026"
            },
            {
                "id": 4,
                "projectId": "001",
                "typeId": 1,
                "statusId": 1,
                "locationId": 1,
                "building": "1",
                "section": "1",
                "floor": 4,
                "floorsNumber": 17,
                "ceilingHeight": "3,50",
                "number": "21",
                "rooms": 1,
                "area": 42,
                "totalCost": 11500000,
                "price": 200000,
                "decoration": "Без отделки",
                "compass": "На Север",
                "views": "На двор, на парк",
                "planPictureUrl": "http://crm.api/images/object1.png",
                "advantages": ["преимущество 1","преимущество 2"],
                "readyDate": "3 квартал 2026"
            },
            {
                "id": 5,
                "projectId": "001",
                "typeId": 1,
                "statusId": 1,
                "locationId": 1,
                "building": "1",
                "section": "1",
                "floor": 5,
                "floorsNumber": 17,
                "ceilingHeight": "3,50",
                "number": "21",
                "rooms": 1,
                "area": 46,
                "totalCost": 12000000,
                "price": 250000,
                "decoration": "Без отделки",
                "compass": "На Север",
                "views": "На двор, на парк",
                "planPictureUrl": "http://crm.api/images/object1.png",
                "advantages": ["преимущество 1","преимущество 2"],
                "readyDate": "3 квартал 2026"
            },
            {
                "id": 6,
                "projectId": "001",
                "typeId": 1,
                "statusId": 1,
                "locationId": 1,
                "building": "1",
                "section": "1",
                "floor": 6,
                "floorsNumber": 17,
                "ceilingHeight": "3,50",
                "number": "21",
                "rooms": 1,
                "area": 34,
                "totalCost": 9500000,
                "price": 180000,
                "decoration": "Без отделки",
                "compass": "На Север",
                "views": "На двор, на парк",
                "planPictureUrl": "http://crm.api/images/object1.png",
                "advantages": ["преимущество 1","преимущество 2"],
                "readyDate": "3 квартал 2026"
            },
            {
                "id": 7,
                "projectId": "001",
                "typeId": 1,
                "statusId": 1,
                "locationId": 1,
                "building": "1",
                "section": "1",
                "floor": 7,
                "floorsNumber": 17,
                "ceilingHeight": "3,50",
                "number": "21",
                "rooms": 1,
                "area": 36,
                "totalCost": 9600000,
                "price": 200000,
                "decoration": "Без отделки",
                "compass": "На Север",
                "views": "На двор, на парк",
                "planPictureUrl": "http://crm.api/images/object1.png",
                "advantages": ["преимущество 1","преимущество 2"],
                "readyDate": "3 квартал 2026"
            },
            {
                "id": 8,
                "projectId": "001",
                "typeId": 1,
                "statusId": 1,
                "locationId": 1,
                "building": "1",
                "section": "1",
                "floor": 8,
                "floorsNumber": 17,
                "ceilingHeight": "3,50",
                "number": "21",
                "rooms": 4,
                "area": 89,
                "totalCost": 19000000,
                "price": 170000,
                "decoration": "Без отделки",
                "compass": "На Север",
                "views": "На двор, на парк",
                "planPictureUrl": "http://crm.api/images/object1.png",
                "advantages": ["преимущество 1","преимущество 2"],
                "readyDate": "3 квартал 2026"
            },
            {
                "id": 9,
                "projectId": "001",
                "typeId": 1,
                "statusId": 1,
                "locationId": 1,
                "building": "1",
                "section": "1",
                "floor": 9,
                "floorsNumber": 17,
                "ceilingHeight": "3,50",
                "number": "21",
                "rooms": 3,
                "area": 70,
                "totalCost": 16000000,
                "price": 220000,
                "decoration": "Без отделки",
                "compass": "На Север",
                "views": "На двор, на парк",
                "planPictureUrl": "http://crm.api/images/object1.png",
                "advantages": ["преимущество 1","преимущество 2"],
                "readyDate": "3 квартал 2026"
            },
            {
                "id": 10,
                "projectId": "001",
                "typeId": 1,
                "statusId": 1,
                "locationId": 1,
                "building": "1",
                "section": "1",
                "floor": 10,
                "floorsNumber": 17,
                "ceilingHeight": "3,50",
                "number": "21",
                "rooms": 5,
                "area": 102,
                "totalCost": 22000000,
                "price": 100000,
                "decoration": "Без отделки",
                "compass": "На Север",
                "views": "На двор, на парк",
                "planPictureUrl": "http://crm.api/images/object1.png",
                "advantages": ["преимущество 1","преимущество 2"],
                "readyDate": "3 квартал 2026"
            }
        ]
    }
    
}